"use client";

import { useEffect } from "react";

import { useStyles } from "./styles";
import { MODELS } from "../constants";
import { useAppSelector } from "@/redux/store";

interface TotalImagesSelectProps {
  selectedModel: string;
  totalImages: number;
  setTotalImages: (value: number) => void;
}

const TotalImagesSelect: React.FC<TotalImagesSelectProps> = ({
  selectedModel,
  totalImages,
  setTotalImages,
}) => {
  const { classes, cx } = useStyles();
  const user = useAppSelector((state) => state.user.user);
  const isSubscribed = Boolean(user && user.subscriptionType !== "free");

  const getAvailableTotals = () => {
    const model = MODELS.find((m) => m.name === selectedModel);
    const baseImageTotals = model?.includedImageTotals || [1, 2, 4];

    if (selectedModel === "imagen-4" && !isSubscribed) {
      return [1];
    }

    return baseImageTotals;
  };

  const availableTotals = getAvailableTotals();

  useEffect(() => {
    if (!availableTotals.includes(totalImages)) {
      setTotalImages(1);
    } else if (availableTotals.includes(4)) {
      setTotalImages(4);
    }
  }, [availableTotals]);

  return (
    <div className={classes.container}>
      <h3 className={classes.heading}>Number of Images</h3>
      <div className={classes.controls}>
        <button
          className={cx(classes.controlButton, {
            [classes.selected]: totalImages === 1,
          })}
          disabled={!availableTotals.includes(1)}
          onClick={() => setTotalImages(1)}
        >
          <svg
            viewBox="0 0 32 32"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className={classes.controlButtonIcon}
          >
            <rect x="8" y="8" width="16" height="16" rx="2" />
          </svg>
          1
        </button>
        <button
          className={cx(classes.controlButton, {
            [classes.selected]: totalImages === 2,
          })}
          disabled={!availableTotals.includes(2)}
          onClick={() => setTotalImages(2)}
        >
          <svg
            viewBox="0 0 32 32"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className={classes.controlButtonIcon}
          >
            <rect x="6" y="6" width="8" height="10" rx="1"></rect>
            <rect x="18" y="16" width="8" height="10" rx="1"></rect>
          </svg>
          2
        </button>
        <button
          className={cx(classes.controlButton, {
            [classes.selected]: totalImages === 4,
          })}
          disabled={!availableTotals.includes(4)}
          onClick={() => setTotalImages(4)}
        >
          <svg
            viewBox="0 0 32 32"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className={classes.controlButtonIcon}
          >
            <rect x="4" y="4" width="10" height="10" rx="1"></rect>
            <rect x="18" y="4" width="10" height="10" rx="1"></rect>
            <rect x="4" y="18" width="10" height="10" rx="1"></rect>
            <rect x="18" y="18" width="10" height="10" rx="1"></rect>
          </svg>
          4
        </button>
      </div>
    </div>
  );
};

export default TotalImagesSelect;
